// extracted by mini-css-extract-plugin
export default {"main":"OMVI3C","logo":"FTdH9Q","widescreen":"y0HAww","header":"iYjUEG","subHeader":"FzvbKP","content":"M7D_Pr","nav":"ikJtz6"};